import { IReportRedirectData } from './types';

export const reportRedirectData: IReportRedirectData[] = [];

export const DEFAULT_REPORT_REDIRECT_URL = 'https://t.me/WakadooHelp';
